import { useLayoutEffect, type RefObject } from "react";

// Publish an element's real rendered height as a CSS variable on the page.
//
// The fixed chrome (crew bar, tab bar) changes height with the phone's text
// size and the home-indicator gap, so anything that has to fit around it reads
// the measured value instead of guessing a pixel number.
export function useCssHeight(ref: RefObject<HTMLElement>, name: string) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const root = document.documentElement;
    const publish = () => root.style.setProperty(name, `${Math.ceil(el.getBoundingClientRect().height)}px`);
    publish();
    const ro = new ResizeObserver(publish);
    ro.observe(el);
    return () => { ro.disconnect(); root.style.removeProperty(name); };
  }, [ref, name]);
}
